import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const PushNotificationsRoutes: Routes = [
  {
    path: "push-notifications",
    loadComponent: () =>
      import("./push-notifications/push-notifications.component").then(
        (m) => m.PushNotificationsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./push-notifications-list/push-notifications-list.component").then(
            (m) => m.PushNotificationsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./push-notifications-form/push-notifications-form.component").then(
            (m) => m.PushNotificationsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./push-notifications-form/push-notifications-form.component").then(
            (m) => m.PushNotificationsFormComponent,
          ),
      },
    ],
  },
];
